import "./App.scss";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppNavigator from "./navigation/App.navigator";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <AppNavigator />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
